import React, { useState, useEffect, useRef } from 'react';
import { message, Table, Popover } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import { ContextHandler } from '../../public/js/contextHandler';
import moment from 'moment';//日期格式化导包

import searchImg from '../../public/img/newMain/Search.png';
import sortImg from '../../public/img/newMain/Sort.png';
import resetImg from '../../public/img/newMain/Reset.png';
import exportImg from '../../public/img/newMain/Export.png';

import './partnerSeeAllApplications.css';
import { partnerCheckLogin } from '../newMain/partnerMain';
import PartnerSeeAllApplicationsSort from './partnerSeeAllApplicationsSort';

const PartnerSeeAllApplications = (props) => {
    const history = useHistory();
    const { showStatus } = useParams();
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const searchModelRef = useRef({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [isReset, setIsReset] = useState(false);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [jobSortPostModel, setJobSortPostModel] = useState({});

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        searchStudentApplications(10, 1)
    }, []);

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        searchStudentApplications(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        searchStudentApplications(pageSizeNew, 1, "Y");
    }

    const searchChange = (key, value) => {
        setSearchModel(model => {
            searchModelRef.current = { ...model, ...{ [key]: value } };
            return { ...model, ...{ [key]: value } };
        });
        searchStudentApplications(pageSize, 1)
    }

    const searchStudentApplications = (pageSizeNew, currentPageNew, flag, jobSortModel) => {
        let model = {};
        // if ("Y" === flag) {     // 翻页
        //     model = oldSearchModel;
        // } else if ("reset" === flag) {
        //     model = {}
        // } else {
        //     model = searchModel;
        // }
        // const title = searchModel.jobTitle;
        const title = searchModelRef.current.jobTitle;
        if (jobSortPostModel) {
            model = { ...jobSortPostModel }
        }
        if (jobSortModel) {
            model = { ...jobSortModel }
        }
        model.jobTitle = title
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        if (showStatus === 'processed') {
            model.jobApplStatusList = ["IP_PROCESSING", "REQUEST_DOCUMENT", "OFFER"];
        } else if (showStatus === 'receipt') {
            model.jobApplStatusList = ['PEND_IP_RECEIPT'];
        } else if (showStatus === 'document') {
            model.jobApplStatusList = ['DOCUMENT_ATTACHED'];
        } else if (showStatus === 'offer') {
            model.jobApplStatusList = ['OFFER'];
        } else if (showStatus === 'offerReview') {
            model.jobApplStatusList = ['OFFER_DECLINED', 'IN_PROGRESS'];
            model.offerFlag = 'Y'
        } else {
            model.jobApplStatusList = ['PEND_IP_RECEIPT', 'IP_PROCESSING', 'REQUEST_DOCUMENT', 'DOCUMENT_ATTACHED', 'OFFER', 'DECLINED', 'OFFER_DECLINED', 'IN_PROGRESS', 'WITHDRAWN', 'SPECIAL_ARRANGEMENT', 'STUDENT_WITHDRAWN'];
        }
        model.partnerId = Config.partnerInfo?.partnerId;
        Base.callBackApi("partnerHome/searchApplList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTables(data?.object?.list ?? []);
                setTablesCount(data?.object?.total ?? 0);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const reset = () => {
        setSearchModel({});
        searchModelRef.current = {};
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        setJobSortPostModel({})
        setIsReset(true)
        searchStudentApplications(10, 1, "reset", {})
    }

    const jumpAppl = (record) => {
        history.push("/partner/partnerReviewStudentApplication/" + record.jobApplId);
    }

    const handleOpenChange = (newOpen) => {
        setPopoverVisible(newOpen);
    };

    const handleOpenChange2 = (newOpen, status, jobSortJobPostModel) => {
        if (status) {
            setJobSortPostModel(jobSortJobPostModel)
            searchStudentApplications(10, 1, null, jobSortJobPostModel)
        }
        setIsReset(false)
        setPopoverVisible(newOpen);
    };

    const tableColumns = {
        jobId: "job_id",
        jobTitle: "job_title",
        progTitle: "prog_title",
        jobPostStatus: "job_post_status",
        studentAcctId: "student_acct_id",
        firstName: "first_name",
        applyDate: "apply_date",
        jobApplStatus: "job_appl_status",
        attentionNeeded: "attention_needed",
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!jobSortPostModel.orderBy) {
            if (orderBy !== jobSortPostModel.orderBy) {
                jobSortPostModel.orderBy = orderBy;
                searchStudentApplications(10, 1)
            }
        }
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Job ID',
            dataIndex: 'jobId',
            className: 'tableWidth8',
            render: text => text ? '#' + text : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: 'Job Title',
            dataIndex: 'jobTitle',
            className: 'tableWidth19',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
        },
        {
            title: 'Job Post Status',
            dataIndex: 'jobPostStatus',
            className: 'tableWidth12',
            render: (text) => ContextHandler.getMapValue('jobPostStatusMap', text),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobPostStatus') },
        },
        {
            title: 'THEi Programme',
            dataIndex: 'progTitle',
            className: 'tableWidth20',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgramme'>{text}</div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progTitle') },
        },
        {
            title: 'Student ID',
            dataIndex: 'studentAcctId',
            className: 'tableWidth11',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: 'Student',
            className: 'tableWidth11',
            render: (text, record) => <div>{record.firstName + " " + record.lastName}</div>,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'firstName') },
        },
        {
            title: 'Date Applied',
            dataIndex: 'applyDate',
            className: 'tableWidth10',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'applyDate') },
        },
        {
            title: 'Status',
            dataIndex: 'jobApplStatus',
            width: 180,
            render: text => (
                <div className='tableStatusBox'>
                    {context.partnerJobApplStatusMap.map(item => item.value === text && <div className={'tableStatus ' + item.value}>
                        {item.label}
                    </div>)}
                </div>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobApplStatus') },
        },
        {
            title: 'Attention Needed',
            dataIndex: 'attentionNeeded',
            className: 'tableWidth10',
            render: (text) => <div className='newInfoStyle'>{ContextHandler.getMapValue('attentionNeededMap', text)}</div>,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'attentionNeeded') },
        },
        {
            title: 'Action',
            dataIndex: '',
            fixed: 'right',
            width: 80,
            render: (text, value) => (
                <div className='tableAction' onClick={() => jumpAppl(value)}><img src={exportImg} /></div>
            )
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className='websiteTemplate partnerSeeAllApplications'>
            <div className='homeTitle'>All Student Applications</div>
            <div className='websiteSysSearchRow'>
                <div className='websiteSysSearchBar'>
                    <input style={{ paddingLeft: '11px' }} placeholder="Search By job ID, job title or by student name" value={searchModel.jobTitle || ''}
                        onKeyDown={(e) => e.key === "Enter" ? searchStudentApplications(pageSize, 1, "N", true) : null}
                        onChange={(e) => searchChange('jobTitle', e.target.value)} />
                    <img src={searchImg} onClick={() => searchStudentApplications(pageSize, 1, "N", true)} />
                </div>
                <Popover placement="topRight" trigger="click" open={popoverVisible}
                    onOpenChange={handleOpenChange} content={
                        <PartnerSeeAllApplicationsSort isReset={isReset} onOpenChange={handleOpenChange2} />
                    }
                    getPopupContainer={() => document.getElementById('sortButton')}
                >
                    <div className='websiteSysButton sortButton' id='sortButton'><img src={sortImg} />Sort</div>
                </Popover>
                <div className='websiteSysButton sortButton' onClick={reset}><img src={resetImg} />Reset</div>
            </div>

            <div className="sysTable" id="tableOne" style={{ marginTop: '20px' }} >
                <Table
                    scroll={{ x: 1200 }}
                    rowKey="jobApplId"
                    columns={columns} //列名
                    dataSource={tables} //数据
                    pagination={{  //分页
                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                        onChange: onChange,            //上页下页或者跳页方法
                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                        total: tablesCount,             //总共多少条数据
                        current: current,         //当前页
                        pageSize: pageSize,       //每页显示多少条数据
                        defaultCurrent: 1,                               //默认当前页为1
                        size: "small"
                    }}
                    onChange={handleTableChange}
                />
            </div>
        </div>
    )

}

export default PartnerSeeAllApplications;